/**
 * Copyright since 2022 Trusted shops
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to tech@202-ecommerce.com so we can send you a copy immediately.
 *
 * @author 202 ecommerce <tech@202-ecommerce.com>
 * @copyright 2022 Trusted shops
 * @license https://opensource.org/licenses/AFL-3.0  Academic Free License (AFL 3.0)
 *
 * This source file is loading the components connector.umd.js and eventsLib.js
 * (itself subject to the Trusted Shops EULA https://policies.etrusted.com/IE/en/plugin-licence.html)  to connect to Trusted Shops. For these components, you will find below a list of the open source libraries we use for our Services.
 * Please note that the following list may be subject to amendments and modifications, and does not thus claim (perpetual) exhaustiveness. You can always refer to the following website for up-to-date information on the open source software Trusted Shops uses:
 * https://policies.etrusted.com/IE/en/plugin-licence.html
 *
 * Name                Licence         Copyright Disclaimer
 * axios               MIT     Copyright (c) 2014-present (Matt Zabriskie)
 * babel               MIT     Copyright (c) 2014-present (Sebastian McKenzie and other Contributors)
 * follow-redirects    MIT     Copyright (c) 2014–present (Olivier Lalonde, James Talmage, Ruben Verborgh)
 * history             MIT     Copyright (c) 2016-2020 (React Training), Copyright (c) 2020-2021 (Remix Software)
 * hookform/resolvers  MIT     Copyright (c) 2019-present (Beier(Bill) Luo)
 * inherits            ISC     Copyright (c) 2011-2022 (Isaac Z. Schlueter)
 * js-tokens           MIT     Copyright (c) 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021 (Simon Lydell)
 * lodash              MIT     Copyright (c) (OpenJS Foundation and other contributors (https://openjsf.org/)
 * lodash-es           MIT     Copyright (c) (OpenJS Foundation and other contributors (https://openjsf.org/)
 * loose-envify        MIT     Copyright (c) 2015 (Andreas Suarez)
 * nanoclone           MIT     Copyright (c) 2017 (Anton Kosykh)
 * path                MIT     Copyright (c) (Joyent, Inc. and other Node contributors.)
 * preact              MIT     Copyright (c) 2015-present (Jason Miller)
 * preact-router       MIT     Copyright (c) 2015 (Jason Miller)
 * process             MIT     Copyright (c) 2013 (Roman Shtylman)
 * property-expr       MIT     Copyright (c) 2014 (Jason Quense)
 * react-hook-form     MIT     Copyright (c) 2019-present (Beier(Bill) Luo)
 * regenerator-runtime MIT     Copyright (c) 2014-present (Facebook, Inc.)
 * resolve-pathname    MIT     Copyright (c) 2016-2018 (Michael Jackson)
 * tiny-invariant      MIT     Copyright (c) 2019 (Alexander Reardon)
 * tiny-warning        MIT     Copyright (c) 2019 (Alexander Reardon)
 * toposort            MIT     Copyright (c) 2012 (Marcel Klehr)
 * types/lodash        MIT     (none)
 * util                MIT     Copyright (c) (Joyent, Inc. and other Node contributors)
 * value-equal         MIT     Copyright (c) 2016-2018 (Michael Jackson)
 * yup                 MIT     Copyright (c) 2014 (Jason Quense)
 * zustand             MIT     Copyright (c) 2019 (Paul Henschel)
 */

const adaptProductMiniature = () => {
  const $miniatures = $('.js-product-miniature');

  Array.from($miniatures).forEach((e) => {
    const $thumbnailContainer = $(e).find('.thumbnail-container');
    const $highlightedInformations = $(e).find('.highlighted-informations');
    const $widget = $(e).find('.ts-wdg-loc-pl-wrapper');

    if ($widget.length > 0) {
      adaptThumbnailContainer(e);

      if (!$thumbnailContainer.find('.thumbnail-top').length) {
        $thumbnailContainer.prepend($('<div class="thumbnail-top"></div>'));
        const $thumbnailTop = $(e).find('.thumbnail-top');
        const $productThumbnail = $(e).find('.product-thumbnail');
        $thumbnailTop.append($productThumbnail);
        $thumbnailTop.append($highlightedInformations);
      }
    }
  });
}

const adaptThumbnailContainer = (element) => {
  setTimeout(() => {
    const $widget = $(element).find('.ts-wdg-loc-pl-wrapper');
    const $thumbnailContainer = $(element).find('.thumbnail-container');
    $thumbnailContainer.addClass('with-ts-widget');

    if ($widget.height() > 65 || $widget.height() == 0) {
      $thumbnailContainer.addClass('with-ts-widget-expanded');
    }
  }, 500);
}

$(() => {
  const parentObjProductDesc = $('.ts-wdg-loc-pd-wrapper');
  const parentObjProductName = $('.ts-wdg-loc-pn-wrapper');
  const parentObjAnchorStars = $('etrusted-product-review-list-widget-product-star-extension');
  const parentObjHeader = $('.ts-wdg-loc-hd-wrapper');
  const mobileTopMenuWrapper = $('.header-top .container');
  
  if ($('#description').length) {
    if (typeof window.controller !== 'undefined') {
      if (window.controller === 'product') {
        parentObjProductDesc.detach().appendTo($('body').find('#description'));
      }
    } else {
      parentObjProductDesc.detach().appendTo($('body').find('#description'));
    }
  }
  
  if (typeof window.controller !== 'undefined') {
    if (window.controller === 'product') {
      parentObjProductName.detach().insertAfter($('body').find('h1'));
      parentObjAnchorStars.detach().insertAfter($('body').find('h1'));
    }
  } else {
    parentObjProductName.detach().insertAfter($('body').find('h1'));
    parentObjAnchorStars.detach().insertAfter($('body').find('h1'));
  }

  if (typeof prestashop !== 'undefined') {
    prestashop.on('updateProductList', () => {
      adaptProductMiniature();
    });
  }

  const moveHeaderWidget = () => {    
      mobileTopMenuWrapper.append(parentObjHeader);
  }

  if (parentObjHeader.length) {
    parentObjHeader.addClass('row');
    moveHeaderWidget();
  }

  $(window).on('resize', () => {
    moveHeaderWidget();
  });
});

$(window).on('load', () => adaptProductMiniature());
